import React from 'react';
export function GuaranteeSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-57" data-mp="1i4zlaiypf6jm">
      <div className="max-w-3xl mx-auto text-center" data-id="element-58" data-mp="4uqc2rqwfur7">
        <img src="https://cdn.magicpatterns.com/uploads/brqUmSz4yCe5C97rvxKRZm/garantia_de_7_dias.jpg" alt="Garantía de 7 días" className="w-32 h-32 mx-auto mb-4 object-contain" data-id="element-59" data-mp="4vjkdx5iasbg" />

        <h2 className="text-2xl md:text-3xl font-black text-[#14356B] mb-3" data-id="element-60" data-mp="ev0rmj0epe9j">
          Garantía de satisfacción de 7 días
        </h2>

        <div className="max-w-2xl mx-auto text-lg text-gray-700 space-y-3" data-id="element-61" data-mp="jqpryok92z6w">
          <p className="font-medium" data-id="element-62" data-mp="nsb4u9wsbdh3">
            Queremos que estés 100% conforme con tu compra.
          </p>
          <p data-id="element-63" data-mp="smxd447kkpwy">
            Probalo sin riesgo. Si el material no te resulta útil, podés
            solicitar la devolución dentro de los 7 días.
          </p>
          <p className="font-semibold text-[#157C8B]" data-id="element-64" data-mp="12k39nryyd94k">
            Comprá con tranquilidad: tu inversión está protegida.
          </p>
        </div>
      </div>
    </section>;
}